export class Resource {
    id: number;
    name: string;
    text: string;
    create: Date;
    edited: Date;
}